import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";


function DetailBlog() {
    const params = useParams();
    const [newsDetail, SetNewsDetail] = useState([]);
    const [eventList, SetEvent] = useState([]);
    const [newsList, SetNews] = useState([]);
    const urlImg = "https://dev.jftheskinspecialist.com/images/news/";

    useEffect(() => {
        fetch(`https://dev.jftheskinspecialist.com/api/newsdetail/${params.id}`)
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                //console.log(datas.data);
                SetNewsDetail(datas.data[0]);
        });

        fetch('https://dev.jftheskinspecialist.com/api/event')
        .then((res) => {
            return res.json();
        })
        .then((datas) => {
            //console.log(datas.data);
            SetEvent(datas.data);
        });

        fetch('https://dev.jftheskinspecialist.com/api/news')
        .then((res) => {
            return res.json();
        })
        .then((datas) => {
            //console.log(datas.data);
            SetNews(datas.data);
        });

        //console.log(newsDetail);
    }, []);

    const getLang = localStorage.getItem('lang_code');

    return (
        <div className="p-4 bg-[#fefaed]">
            <div class="flex flex-wrap justify-between">
                <div class="bg-white w-full md:w-8/12 px-4 mb-8 rounded"><br />
                    <img src={urlImg + '' + newsDetail.featured_image} alt="" class="w-full h-[360px] object-cover rounded" />
                        <h2 class="text-4xl font-bold mt-4 mb-2" style={{ fontFamily: 'MuseoSansRounded900', fontSize: 24 }}>
                            {getLang === 'id' ?
                                newsDetail.name
                                :
                                newsDetail.name_en
                            }
                        </h2>
                        <p class="text-gray-700 mb-4" style={{ fontFamily: 'MuseoSansRounded900', fontSize: 12 }}>
                            {getLang === 'id' ?
                                <div dangerouslySetInnerHTML={{ __html: newsDetail.content }}></div>
                                :
                                <div dangerouslySetInnerHTML={{ __html: newsDetail.content_en }}></div>
                            }
                        </p>
                        
                </div>
                <div class="w-full md:w-4/12 px-4 mb-8">
                    <div class="bg-gray-100 px-4 py-6">
                        <h3 class="font-bold text-left" style={{ fontFamily: 'MuseoSansRounded900', fontSize: 18 }}>
                            <span class="text-[#ffd988] drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">
                                {getLang === 'id' ? 'BERITA' : 'NEWS'}
                            </span>
                        </h3>
                    </div>
                    <div class="flex flex-col divide-y dark:divide-gray-300 bg-white px-4" style={{ fontFamily: 'MuseoSansRounded900', fontSize: 14 }}>
                        {newsList.filter((item) => item.id !== params.id).map((data_news, indexnews_list) => (
                            <div class="flex px-1 py-4" key={indexnews_list}>
                                <img alt="" class="flex-shrink-0 object-cover w-20 h-20 mr-4 dark:bg-gray-500" src={urlImg + '' + data_news.featured_image} />
                                    <div class="flex flex-col flex-grow">
                                    <a rel="noopener noreferrer" href={`/detailblog/${data_news.id}`} class="font-serif hover:underline">
                                        {getLang === 'id' ?
                                            data_news.name
                                            :
                                            data_news.name_en
                                        }
                                        </a>
                                       <p class="mt-auto" style={{ fontFamily: 'MuseoSansRounded400', fontSize: 12 }}>
                                        {data_news.created_at}
                                        </p>
                                    </div>
                            </div>
                        ))}
                    </div>

                    <div class="bg-gray-100 px-4 py-6">
                        <h3 class="font-bold text-left" style={{ fontFamily: 'MuseoSansRounded900', fontSize: 18 }}>
                            <span class="text-[#ffd988] drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">
                                {getLang === 'id' ? 'INFO' : 'EVENT'}
                            </span>
                        </h3>
                    </div>
                    <div class="flex flex-col divide-y dark:divide-gray-300 bg-white px-4" style={{ fontFamily: 'MuseoSansRounded900', fontSize: 14 }}>
                        {eventList.filter((items) => items.id !== params.id).map((data_event, indexevent_list) => (
                            <div class="flex px-1 py-4" key={indexevent_list}>
                                <img alt="" class="flex-shrink-0 object-cover w-20 h-20 mr-4 dark:bg-gray-500" src={urlImg + '' + data_event.featured_image} />
                                <div class="flex flex-col flex-grow">
                                    <a rel="noopener noreferrer" href={`/detailblog/${data_event.id}`} class="font-serif hover:underline">
                                        {getLang === 'id' ?
                                            data_event.name
                                            :
                                            data_event.name_en
                                        }
                                    </a>
                                    <p class="mt-auto" style={{ fontFamily: 'MuseoSansRounded400', fontSize: 12 }}>
                                        {data_event.created_at}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DetailBlog;
